import { Component, OnInit, Input, forwardRef,EventEmitter, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormGroup } from '@angular/forms';

const noop = () => {
};


export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SearchBarComponent),
  multi: true
};

@Component({
  selector: 'ark-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class SearchBarComponent implements ControlValueAccessor {

  searchModel:string = '';
  @Input() label: string;
  @Input() type: string = 'text';
  @Input() customModel: string;
  @Input() placeholder: string;
  @Input() group: FormGroup;
  @Input() controlname: string;
  @Output() searchModelChange: EventEmitter<any> = new EventEmitter();

  private innerValue: any = '';

  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  //get accessor
  get value(): any {
    return this.innerValue;
  };

  //set accessor including call the onchange callback
  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(v);
    }
  }

  //Set touched on blur
  onBlur() {
    this.onTouchedCallback();
  }

  //From ControlValueAccessor interface
  writeValue(value: any) {
    if (value !== this.innerValue) {
      this.innerValue = value;
    }
  }

  //From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  preventNonNumericalInput(e) {
    if (this.type == 'number') {
      const pattern = new RegExp(/\d/); // '\d'
      if (e.key == 'Backspace') {
          return true;
      } else {
          return pattern.test(e.key);
      }
    }  
  }

  updateSearchModel(value) {
    this.searchModel = value;
    this.searchModelChange.emit(this.searchModel);
  }
}
